<template>
  <div>
    <v-card
      class="mx-auto"
      max-width="500"
      outlined
      style="border-radius: 25px 25px 30px 30px"
      @click="goToLesson(item)"
    >
      <v-img
        :src="item.thumb ?? 'https://cdn.vuetifyjs.com/images/cards/desert.jpg'"
        height="200px"
      ></v-img>
      <v-card-title>{{ item.title }}</v-card-title>
      <v-card-text>
        {{ item.description }}
        <v-divider> </v-divider>
        <v-row class="mt-0">
          <v-col
            class="d-flex align-center justify-start pb-4"
            cols="12"
            md="6"
          >
            <v-icon>mdi-file-outline</v-icon>
            <span class="grey--text">{{ item.totalLesons }} lessons</span>
          </v-col>
          <v-col
            class="d-flex align-center justify-center pb-4"
            cols="12"
            md="6"
          >
            <v-icon>mdi-clock-outline</v-icon>
            <span class="grey--text">{{ item.estimatedTime }}</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="11">
            <v-progress-linear
              height="7"
              width="70%"
              :value="item.progress"
              striped
              rounded
              color="primary"
            >
            </v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "LessonCard",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    if (this.item) this.localItem = this.item;
  },
  data() {
    return {
      localItem: {},
    };
  },
  methods: {
    goToLesson(item) {
      this.$emit("toLeason", item);
    },
  },
};
</script>
<style scoped></style>
